import { render, staticRenderFns } from "./DelegationUnlockConfirmation.vue?vue&type=template&id=6c5ebab8&"
import script from "./DelegationUnlockConfirmation.vue?vue&type=script&lang=js&"
export * from "./DelegationUnlockConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports